export default __webpack_public_path__ + "assets/manager-testimonial-image-2.jpg";